import InputNumber from './input-number.vue'
export default (Vue) => {
  Vue.component('AbInputNumber', InputNumber)
}
